import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import VerticalSpan from "../../assets/icons/animated-horizontal-lines.gif";
import DownwardArrowsBlack from "../../assets/icons/downward-arrows-black.png";
import YouTube from "react-youtube";

const sxStyles = {
  mainContainer: {
    backgroundColor: "#FED301",
    alignItems: "center",
    display: "flex",
    backgroundSize: "cover",
    justifyContent: "left",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: { xs: "900px", md: "700px" },
    paddingLeft: { xs: 0, md: "10px", xl: "50px" },
    flexDirection: { xs: "column", md: "row" },
  },
  staticCover: {
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "190px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "black",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "32px", md: "45px" },
    fontWeight: "700",
    lineHeight: { xs: "33px", md: "70px" },
    paddingBottom: "5px",
    position: "relative",
    top: "-70px",
    left: "310px",
  },
  title: {
    color: "black",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "36px", md: "45px", xl: "65px" },
    fontWeight: "400",
    lineHeight: { xs: "37px", md: "48px", xl: "68px" },
    textAlign: { xs: "center", md: "left" },
    paddingRight: { xs: 0, md: "350px", xl: "460px" },
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const RemixSection = () => {
  const youtubeOptions = {
    width: "90%",
    height: "500px",
  };
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Stack>
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-330px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-300px",
          }}
        />
        <img
          src={VerticalSpan}
          alt={""}
          style={{
            position: "relative",
            width: "30px",
            height: "15px",
            top: "-270px",
          }}
        />
      </Stack>
      <Stack
        sx={{
          display: "flex",
          marginTop: "20px",
          justifyContent: "left",
          alignItems: { xs: "center", md: "left" },
          marginBottom: "40px",
          width: { xs: "80%", md: "50%", xl: "55%" },
        }}
      >
        <Typography
          sx={{
            color: "black",
            fontFamily: "IBM Plex Sans",
            fontSize: { xs: "36px", md: "45px", xl: "65px" },
            fontWeight: "400",
            lineHeight: { xs: "37px", md: "48px", xl: "68px" },
            textAlign: "center",
            marginBottom: "30px",
            paddingRight: { xs: 0, md: "130px", xl: "230px" },
          }}
        >
          3.{" "}
        </Typography>
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Typography sx={sxStyles.title}>REMIXEÁ UNA</Typography>
        </Box>
        <Stack sx={{ display: { xs: "flex", md: "none" } }}>
          <Typography sx={sxStyles.title}>REMIXEÁ </Typography>
          <Typography sx={sxStyles.title}>UNA SESSION</Typography>
        </Stack>
        <Grid sx={{ display: { xs: "flex", md: "none" } }}>
          <Typography
            sx={{
              color: "black",
              fontFamily: "IBM Plex Sans",
              fontSize: { xs: "36px", md: "45px", xl: "65px" },
              fontWeight: "400",
              lineHeight: { xs: "37px", md: "48px", xl: "68px" },
              textAlign: { xs: "center", md: "left" },
              paddingLeft: { xs: 0, md: "", xl: "40px" },
              paddingRight: { xs: "100px", md: 0 },
            }}
          >
            CON{" "}
          </Typography>
          <Typography
            sx={{
              color: "black",
              fontFamily: "p22-arts-and-crafts",
              fontSize: { xs: "32px", md: "45px", xl: "65px" },
              fontWeight: "700",
              lineHeight: { xs: "33px", md: "70px" },
              paddingBottom: "5px",
              position: "absolute",
              bottom: { xs: "655px", md: "291px", xl: "285px" },
              left: { xs: "180px", md: "382px", xl: "555px" },
            }}
          >
            MIXER
          </Typography>
        </Grid>
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Typography
            sx={{
              color: "black",
              fontFamily: "IBM Plex Sans",
              fontSize: { xs: "36px", md: "45px", xl: "65px" },
              fontWeight: "400",
              lineHeight: { xs: "37px", md: "48px", xl: "68px" },
              paddingRight: { md: "360px", xl: "470px" },
            }}
          >
            SESSION CON
          </Typography>
          <Typography
            sx={{
              color: "black",
              fontFamily: "p22-arts-and-crafts",
              fontSize: { xs: "32px", md: "45px", xl: "65px" },
              fontWeight: "700",
              lineHeight: { xs: "33px", md: "70px" },
              paddingBottom: "5px",
              position: "absolute",
              bottom: { xs: "600px", md: "291px", xl: "285px" },
              left: { md: "405px", xl: "555px" },
            }}
          >
            MIXER
          </Typography>
        </Box>
        <Typography
          sx={{
            color: "black",
            fontFamily: "IBM Plex Sans",
            fontSize: { xs: "20px", md: "28px", xl: "42px" },
            fontWeight: "400",
            lineHeight: { xs: "22px", md: "30px", xl: "44px" },
            marginLeft: { md: "", xl: "13px" },
            marginRight: { md: "80px", xl: "52px" },
          }}
        >
          COMPARTILA EN UN REEL CON EL HASHTAG
        </Typography>
        <Typography
          sx={{
            color: "black",
            fontFamily: "IBM Plex Sans",
            fontSize: { xs: "20px", md: "28px", xl: "42px" },
            fontWeight: "800",
            lineHeight: { xs: "22px", md: "30px", xl: "44px" },
            letterSpacing: "0",
            paddingBottom: "5px",
            textAlign: "left",
            paddingRight: { xs: 0, md: "420px", xl: "600px" },
          }}
        >
          #MiBZRPRemix
        </Typography>
      </Stack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: { xs: "center", md: "flex-end" },
          width: { xs: "90%", md: "50%" },
          paddingTop: { xs: 0, md: 0, xl: "125px" },
        }}
      >
        <YouTube videoId="FDlcxBRLVHE" opts={youtubeOptions} />
        <img
          src={DownwardArrowsBlack}
          style={{
            position: "relative",
            right: "250px",
            bottom: "-50px",
            width: "15px",
            height: "60px",
          }}
          alt={""}
        />
        <Stack>
          <img
            src={VerticalSpan}
            alt={""}
            style={{
              position: "relative",
              width: "30px",
              height: "15px",
              bottom: "240px",
              right: "60px",
            }}
          />
          <img
            src={VerticalSpan}
            alt={""}
            style={{
              position: "relative",
              width: "30px",
              height: "15px",
              bottom: "210px",
              right: "60px",
            }}
          />
          <img
            src={VerticalSpan}
            alt={""}
            style={{
              position: "relative",
              width: "30px",
              height: "15px",
              bottom: "180px",
              right: "60px",
            }}
          />
        </Stack>
      </Stack>
    </Grid>
  );
};

export default RemixSection;
